import {connect} from 'react-redux';
import TasksPage from './TasksPage';
import {getTasks} from '../../actions/getTasks';
import {setPage} from '../../actions/setPage';


const mapStateToProps = ({
  tasks: {list, page, totalPages, totalResultCount}
                         }) => ({
  list, page, totalPages, totalResultCount
});

export default connect(
  mapStateToProps,
  {setPage, getTasks}
)(TasksPage);
